import { faker } from '@faker-js/faker';
import { cleanup } from '@testing-library/react';
import { HttpResponse, http } from 'msw';
import { setupServer } from 'msw/node';

import constants from '../constants';
import redux from '../redux';
import factory from '../redux/api/factory';
import translations from '../translations';

translations.init();

describe('customer group selector reading hierarchy summary', () => {
  // create a mock server
  const server = setupServer(
    http.get(constants.endpoints.get.hierarchySummary, () => {
      return HttpResponse.json(
        factory.buildList(faker.number.int({ max: 10, min: 1 })),
      );
    }),
    http.get(constants.endpoints.get.context, () => {
      return HttpResponse.json({
        customer_group_uuid: faker.string.uuid(),
        customer_uuid: faker.string.uuid(),
        enforce: 'customer_group',
        partner_uuid: faker.string.uuid(),
      });
    }),
  );

  beforeAll(() => {
    server.listen();
  });

  afterAll(() => {
    server.close();
  });

  afterEach(() => {
    server.resetHandlers();
    cleanup();
  });

  it('should read customers', async () => {
    redux.store.dispatch(redux.api.getData());

    await new Promise((resolve) => {
      setTimeout(resolve, 100);
    });

    expect(redux.store.getState().api.data.length).toBeGreaterThan(0);
  });
});
